import styled from "styled-components";
import axios from "axios";
import { useState } from "react";
import { baseURLStatic } from "../../services/authentication.js";
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


const Container=styled.div`
	border: 1px solid grey;
	border-radius:8px;
	margin:25px;
	height:150px;
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:space-between
 `;



export default function SubirImagen(){

	let [url,setUrl]=useState("url de la imagen subida...");
	let [send,setSend]=useState(true)

	let sendImg=async()=>{

		try{
			let imagen=document.getElementById("imagen").files[0];
			const formImagen = new FormData();
			formImagen.append("imagen",imagen);
			const datoImagen=Object.fromEntries(formImagen.entries());
			let rpta= await axios.post(baseURLStatic+'/imagenes/',datoImagen,{headers: {"Content-Type": "multipart/form-data"} });
			setUrl(rpta.data);
			console.log(rpta.data);
		}catch(err){console.log('static : '+err);alert(err.message)}
	
	}


	return(
		<Container>
			<div>subir imagen</div>
			<input id="imagen" type="file"  disabled={send}/>
			
			<Button variant="contained" loadingPosition="start" startIcon={<CloudUploadIcon />} loading={send} onClick={sendImg} >subir</Button>
			<div>
				<label>Ruta hacia la imagen en el servidor</label>
				<input style={{width:"50vw"}} id="url" type="text"  disabled value={url}/>
			</div>

		</Container>
		)
} 